import { render, staticRenderFns } from "./PharmacySiteDataTable.vue?vue&type=template&id=a4a8b128"
import script from "./PharmacySiteDataTable.vue?vue&type=script&lang=js"
export * from "./PharmacySiteDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports